import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { CreditCard, Calendar, Award } from 'lucide-react';

const PaymentDetails = ({ 
  transactionRef, 
  paymentMethod, 
  membershipTier,
  amount, 
  fees, 
  total,
  submittedAt,
  estimatedCompletion
}) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    })?.format(value);
  };

  const formatDate = (date) => {
    return format(new Date(date), "d 'de' MMMM, yyyy - HH:mm", { locale: es });
  };

  const details = [
    {
      icon: CreditCard,
      label: 'Método de Pago',
      value: paymentMethod,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      icon: Award,
      label: 'Plan de Membresía',
      value: membershipTier,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      icon: Calendar,
      label: 'Fecha de Envío',
      value: formatDate(submittedAt),
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      icon: Calendar,
      label: 'Estimado de Verificación',
      value: formatDate(estimatedCompletion),
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  return (
    <div className="bg-card rounded-lg border shadow-sm p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        Detalles del Pago
      </h3>
      <div className="space-y-4 mb-6">
        <div className="flex justify-between items-center pb-3 border-b">
          <span className="text-sm text-muted-foreground">Referencia de Transacción</span>
          <span className="font-mono text-sm font-semibold text-foreground">{transactionRef}</span>
        </div>

        {details?.map((detail, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${detail?.bgColor}`}>
              <detail.icon className={`w-5 h-5 ${detail?.color}`} />
            </div>
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">{detail?.label}</p>
              <p className="text-sm font-medium text-foreground">{detail?.value}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="border-t pt-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Monto de Membresía</span>
          <span className="font-medium text-foreground">{formatCurrency(amount)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Tarifas de Procesamiento</span>
          <span className="font-medium text-foreground">{formatCurrency(fees)}</span>
        </div>
        <div className="flex justify-between text-base font-bold pt-2 border-t">
          <span className="text-foreground">Total</span>
          <span className="text-primary">{formatCurrency(total)}</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;